import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {addChapter} from 'storyboard/actions/add-chapter-actions';
import {deleteChapter} from 'storyboard/actions/delete-chapter-actions';
import {editChapter} from 'storyboard/actions/edit-chapter-actions';
import StoryboardChapterModal from 'storyboard/components/storyboard-chapter-modal';
import * as ModalType from 'storyboard/constants/modal-type';

class StoryboardChapterModalContainer extends React.Component {
  static propTypes = {
    chapterToEdit: PropTypes.object,
    closeModal: PropTypes.func,
    dashboards: PropTypes.array.isRequired,
    data: PropTypes.object.isRequired,
    dispatch: PropTypes.func,
    editChapter: PropTypes.func,
    enums: PropTypes.object.isRequired,
    isOpen: PropTypes.bool,
    title: PropTypes.string,
    type: PropTypes.string,
  };

  static defaultProps = {
    chapterToEdit: null,
    closeModal: () => {},
    dispatch: () => {},
    editChapter: () => {},
    isOpen: false,
    title: '',
    type: '',
  };

  constructor() {
    super();
    this.addChapter = this.addChapter.bind(this);
    this.deleteChapter = this.deleteChapter.bind(this);
    this.editChapter = this.editChapter.bind(this);
  }

  getDashboards(dashboards, chapters, type, chapterToEdit = {}) {
    // The backend forbids the use of the same dashboard
    // in more than one chapter of the same storyboard.
    // Because of this we need to filter the dashboard
    // choices available to users, so that we don't get
    // errors back from chapter add/edit requests.

    // Filter out any previously used dashboards:
    if (type === ModalType.ADD_CHAPTER) {
      return dashboards.filter((dashboard) => {
        for (const chapter of chapters) {
          if (chapter.contentId === dashboard.id) {
            return false;
          }
        }
        return true;
      });
    }

    // Filter out any previously used dashboards --
    // Except the one being edited:
    if (type === ModalType.EDIT_CHAPTER) {
      return dashboards.filter((dashboard) => {
        for (const chapter of chapters) {
          if (
            chapter.contentId === dashboard.id &&
            chapter.contentId !== chapterToEdit.contentId
          ) {
            return false;
          }
        }
        return true;
      });
    }

    return dashboards;
  }

  addChapter(chapter) {
    this.props.dispatch(addChapter(chapter));
  }

  deleteChapter(chapter) {
    this.props.dispatch(deleteChapter(chapter));
  }

  editChapter(chapter) {
    this.props.dispatch(editChapter(chapter));
  }

  render() {
    const dashboards = this.getDashboards(
      this.props.dashboards,
      this.props.data.chapters,
      this.props.type,
      this.props.chapterToEdit,
    );
    return (
      <StoryboardChapterModal
        addChapter={this.addChapter}
        chapterToEdit={this.props.chapterToEdit}
        closeModal={this.props.closeModal}
        dashboards={dashboards}
        data={this.props.data}
        deleteChapter={this.deleteChapter}
        editChapter={this.editChapter}
        enums={this.props.enums}
        isOpen={this.props.isOpen}
        title={this.props.title}
        type={this.props.type}
      />
    );
  }
}

export default connect()(StoryboardChapterModalContainer);
